import a from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import f from "./iconfont.es5471.js";
const d = {
  display: "block"
}, E = ({ size: t = 16, useVw: o, useRem: l, color: n, withColor: c, removeClassName: e, disableSSR: m, style: i, ...p }) => {
  const x = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ a.createElement(f, { disableSSR: m }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "24px-jiaoyi", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: o ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (l ? "rem" : "px"), height: o ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (l ? "rem" : "px"), className: e ? "" : "iconpark-icon", style: x, fill: "none", ...p }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: e ? "" : "24px-äº¤æ"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: e ? "" : "normal",
        fill: c ? r(n, 0, "#262933") : "#262933",
        datafollowfill: c ? r(n, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M12 20.7a8.7 8.7 0 0 0 7.537-13.05.8.8 0 0 1 1.385-.8A10.256 10.256 0 0 1 22.3 12c0 5.689-4.611 10.3-10.3 10.3-5.689 0-10.3-4.611-10.3-10.3C1.7 6.311 6.31 1.7 12 1.7c1.99 0 3.852.566 5.43 1.545a.8.8 0 0 1-.845 1.36A8.7 8.7 0 1 0 12 20.7Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M14.243 8.142a.8.8 0 0 1-.19.838l-5.785 5.722a.8.8 0 0 1-1.125-1.138l4.563-4.513-1.96-.18a.8.8 0 0 1 .146-1.593l3.67.337a.8.8 0 0 1 .68.527ZM9.74 15.77a.8.8 0 0 0 .49 1.365l3.67.337a.8.8 0 0 0 .147-1.594l-1.96-.18 4.562-4.513a.8.8 0 0 0-1.125-1.137L9.74 15.769Z"
        }
      )
    )
  )));
}, h = E;
export {
  h as default
};
